import { REMOVE_AGENDA_ITEM } from '../actionTypes'

export const removeAgendaItem = (data: object) => ({
  type: REMOVE_AGENDA_ITEM.name,
  api: {
    url: 'agenda_items/remove',
    data,
  },
})
